
const LikeButton = ({ isLiked, onClick }) => (
  <button
    onClick={onClick}
    // className={(
    //   "font-semibold hover:underline",
    //   isLiked ? "text-[#385898]" : ""
    // )}

    className={`font-semibold hover:underline ${
      isLiked ? "text-[#385898] " : ""
    }`}
  >
    Like
  </button>
);

export default LikeButton;
